import React from "react";
import { motion } from "framer-motion";

import { AppWrap } from "../../wrapper";
import { images } from "../../constants";

import SearchBar from "../../components/SearchBar/SearchBar";
import ThemeToggle from "../../components/ThemeToggle/ThemeToggle";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => (
  <div className="hero-section">
    <div className="hero-container">
      {/* Left Content */}
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="hero-left"
      >
        {/* Greeting Card */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="greeting-card"
        >
          <div className="greeting-content">
            <span className="wave-emoji">👋</span>
            <div className="greeting-text">
              <p className="greeting-intro">Hello, I am</p>
              <h1 className="hero-title">Lovish Tater</h1>
              <p className="hero-description">
                Full Stack Engineer experienced in building and scaling products
                at fast-moving startups
              </p>
              <p className="hero-description">
                (AI ✦ Web ✦ Mobile ✦ Cloud Infra)
              </p>
            </div>
          </div>
        </motion.div>

        {/* Search Bar */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="search-section"
        >
          <SearchBar />
        </motion.div>
      </motion.div>

      {/* Right Content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className="hero-right"
      >
        {/* Profile Image */}
        <div className="profile-container">
          <img
            src={images.profile}
            alt="Lovish Tater"
            className="profile-image"
          />
          <motion.img
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 0.7 }}
            src={images.circle}
            alt="background circle"
            className="profile-circle"
          />
        </div>

        {/* Tech Stack Icons */}
        <motion.div
          variants={scaleVariants}
          initial="initial"
          animate="whileInView"
          className="tech-icons"
        >
          {[
            images.node,
            images.react,
            images.javascript,
            images.mongodb,
            images.aws,
            images.openai,
          ].map((icon, index) => (
            <motion.div
              key={index}
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{
                duration: 0.6,
                delay: 1 + index * 0.1,
                type: "spring",
                stiffness: 200,
              }}
              className={`tech-icon tech-icon-${index + 1}`}
            >
              <img src={icon} alt="tech icon" />
            </motion.div>
          ))}
        </motion.div>

        {/* Theme Toggle */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 1.2 }}
          className="theme-toggle-container"
        >
          <ThemeToggle />
        </motion.div>
      </motion.div>
    </div>
  </div>
);

export default AppWrap(Header, "home", "app__primarybg");
